import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { TextField, Autocomplete } from "@mui/material";
import { useEffect, useState } from "react";
import CentroDistribuicao from "../../components/classes/CentroDistribuicao";
import CentroDataset from "../../components/data/CentroDataset";

import { useTranslation } from "react-i18next";

export default function CustomAlertStep2(
    props: CustomAlertPropsTypes
) {
    const { t } = useTranslation();

    const dataSet = new CentroDataset();

    const [datPrevistaEntrega, setDatPrevistaEntrega] = useState<Date>(props.datPrevistaEntregaDefault);
    const [centroDestino, setCentroDestino] = useState<string>('');
    const [depositoDestino, setDepositoDestino] = useState<string>('');

    const [centros, setCentros] = useState<CentroDistribuicao[]>([]);

    useEffect(() => {
        if (dataSet.hasCache()) {
            const centrosCache: CentroDistribuicao[] = dataSet.ListarFromCache();
            if (centrosCache) {
                setCentros(centrosCache);
            }
        } else {
            dataSet.ListarAtivos().then((result) => {
                setCentros(result);
                dataSet.AdicionarListaAoCache(result);
            });
        }
    }, []);

    const onChangeDatPrevistaEntrega = (value: string) => {
        if (value.length == 10) {
            setDatPrevistaEntrega(new Date(value))
        }
    }

    const getCentroDestinoId = () => {
        return +centroDestino.split('-')[0];
    }

    return (
        <div className="react-confirm-alert-body">
            <h1>{t("common.warning")}</h1>
            {t("pages.finishiedProduct.text.wantProceed2")}<br /><br />

            <br />
            <div style={{ width: '180px' }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        label={`${t("common.expectedDeliveryDate")}*`}
                        value={datPrevistaEntrega}
                        onChange={(newValue: any) => {
                            if (newValue != 'Invalid Date') {
                                setDatPrevistaEntrega(newValue);
                            }
                        }}
                        inputFormat="dd/MM/yyyy"
                        renderInput={(params: any) => (
                            <TextField
                                {...params}
                                size="small"
                                onChange={(event) => { onChangeDatPrevistaEntrega(event.target.value) }}
                            />
                        )}
                    />
                </LocalizationProvider>
            </div><br />

            <div>
                <Autocomplete
                    value={centroDestino}
                    inputValue={centroDestino}
                    onInputChange={(_event, newInputValue) => {
                        setCentroDestino(newInputValue);
                    }}
                    fullWidth
                    size="small"
                    freeSolo
                    id="autoCompleteCentroPA"
                    disableClearable
                    options={centros.map(
                        (option: any) => option.centro + " - " + option.nome
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={`${t("common.searchDistributionCenter")} *`}
                            InputProps={{
                                ...params.InputProps,
                                type: "search",
                            }}
                        />
                    )}
                />
            </div><br />

            <div>
                <TextField
                    fullWidth
                    size="small"
                    label={t("common.destinationDeposit")}
                    onChange={(event: any) => setDepositoDestino(event.target.value)}
                    value={depositoDestino}
                />
            </div><br />

            <small><b>*</b>{t("pages.finishiedProduct.text.wantProccedClickYes")}</small>
            <div className="react-confirm-alert-button-group">
                <button onClick={() => props.onClickYes(datPrevistaEntrega, getCentroDestinoId(), depositoDestino)}>{t("common.yes")}</button>
                <button onClick={props.onClose}>{t("common.no")}</button>
            </div>
        </div>
    );
}

interface CustomAlertPropsTypes {
    onClose: any;
    onClickYes: any;
    datPrevistaEntregaDefault: Date;
}
